import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrPage } from '../fr-page-layout/fr-page';
import { FrEventPageHeader } from '../fr-event-common-components/fr-event-page-header';
import { FREventPageFooter } from '../fr-event-common-components/fr-event-page-footer';
import { FrEventProviders } from '../fr-assigned-event-page/components/fr-event-providers';
import FrEventDetailsTabs from './components/fr-event-details-tabs';
import { useGetEventIdAndTabNameFromParams } from './hooks/use-get-event-id-and-tab-name-from-params';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrEventDetailsPage() {
    const { eventId, requestedTab } = useGetEventIdAndTabNameFromParams();
    const { query: eventQuery } = useIntegratedForm();

    // Only show the full-page loader on the first load, when there's no cached data yet.
    // On a background refetch (like the post-save one when returning from the Edit Event
    // page) we already have the data, so keep the page up and let it refresh in place.
    // Using `isFetching` here would blank the page cause a flicker effect.
    if (eventQuery.isInitialLoading) {
        return <LoadingIndicator />;
    }

    return (
        <FrEventProviders eventId={eventId}>
            <FrPage>
                <FrEventPageHeader />
                {eventId && <FrEventDetailsTabs eventId={eventId} requestedTab={requestedTab} />}
                <FREventPageFooter hideMoreDetailsBtn />
            </FrPage>
        </FrEventProviders>
    );
}
